<div class="company-vacancies" *ngIf="company">
  <div class="company-vacancies__hero" [style.backgroundColor]="company.headerColor || '#89CCDC'">
    <div class="vacancy-hero">
      <button class="company-vacancies__back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>
        <span>{{ 'companies.vacancies.back_to' | translate }} {{ company.name }}</span>
      </button>
      <h1 class="vacancy-hero__title">{{ 'companies.vacancies.vacancies_at' | translate }} {{ company.name }}</h1>
    </div>
  </div>

  <div class="vacancy-container company-vacancies__content">
    <div class="vacancy-grid">
      <bwc-vacancy-card
        *ngFor="let vacancy of visibleVacancies"
        [vacancy]="vacancy"
        [isLiked]="isLiked(vacancy.id)"
        (liked)="toggleLike($event)"
        (cardClick)="openDetail($event)"
      ></bwc-vacancy-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>

  <bwc-vacancy-detail
    *ngIf="detailData"
    [data]="detailData"
    (closed)="closeDetail()"
  ></bwc-vacancy-detail>
</div>
